export default __webpack_public_path__ + "static/The Backdrop_image 6_map_780w-bcc15654162161e20bfce8f3d3eb538c.png";